import { render, staticRenderFns } from "./branch-payment.vue?vue&type=template&id=16aad168"
import script from "./branch-payment.vue?vue&type=script&lang=js"
export * from "./branch-payment.vue?vue&type=script&lang=js"
import style0 from "./branch-payment.vue?vue&type=style&index=0&id=16aad168&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports